export default __webpack_public_path__ + "static/media/photo14.1001cfc2.jpg";